import React, { useEffect, useRef, useState } from 'react';

import {
  StyledCarousel,
  StyledCarouselItem,
  StyledNavigationButton,
} from '@componentsV2/Carousel/styles';
import Link from '../../components/atomic/Link';
import { looksLikeUrl } from '../../utils/looksLikeUrl';
import { isNativeEnv } from '../../utils/nativeBridge';

const Carousel = ({
  items,
  showLink = false,
  autoSlide = 0,
  startSlide = 0,
  onCarouselNavigation,
  onLinkClick,
  linkText,
  buttonUrls,
}) => {
  const [currentSlide, setCurrentSlide] = useState(startSlide);
  const [manuallySlided, setManuallySlided] = useState(false);
  const [slideWidth, setSlideWidth] = useState(undefined);
  const [slideHeight, setSlideHeight] = useState(undefined);
  const carouselRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const nativeEnv = isNativeEnv();

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const swipeDistance = touchEndX.current - touchStartX.current;
    const swipeThreshold = 50;

    if (swipeDistance > swipeThreshold) {
      setCurrentSlide((prevIndex) =>
        prevIndex === 0 ? items.length - 1 : prevIndex - 1
      );
    } else if (swipeDistance < -swipeThreshold) {
      setCurrentSlide((prevIndex) =>
        prevIndex === items.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  const handleCarouselNavigation = (index) => {
    setCurrentSlide(index);
    setManuallySlided(true);
    if (onCarouselNavigation) {
      onCarouselNavigation(index);
    }
  };

  const handleLinkClick = (url) => {
    onLinkClick(url);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (slideWidth && autoSlide) {
        if (!manuallySlided) {
          setCurrentSlide((prev) => (prev + 1) % items.length);
        }
        setManuallySlided(false);
      }
    }, autoSlide * 1000);
    return () => clearInterval(interval);
  }, [slideWidth, manuallySlided]);

  useEffect(() => {
    if (carouselRef.current) {
      setSlideWidth(carouselRef.current.getBoundingClientRect().width);
      setSlideHeight(carouselRef.current.getBoundingClientRect().height);
    }
  }, [carouselRef?.current?.getBoundingClientRect().height]);
  return (
    <StyledCarousel style={{ height: slideHeight }}>
      <div
        ref={carouselRef}
        className="carousel_mover"
        style={{ left: `-${currentSlide * slideWidth}px` }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {items.map((item, index) => (
          <StyledCarouselItem>
            {item}
            {showLink && (
              <Link
                to={buttonUrls[index]}
                className="more_link"
                isExternal={looksLikeUrl(buttonUrls[index])}
                openInNewTab={!nativeEnv && looksLikeUrl(buttonUrls[index])}
                isNoPadding
                onClick={() => handleLinkClick(buttonUrls[index])}
              >
                {linkText}
              </Link>
            )}
          </StyledCarouselItem>
        ))}
      </div>
      <div className="carousel_navigation">
        {items.map((_, index) => (
          <StyledNavigationButton
            aria-label="Navigate carousel"
            type="button"
            className="nav_page"
            onClick={() => handleCarouselNavigation(index)}
          >
            <span className={currentSlide === index && 'active'} />
          </StyledNavigationButton>
        ))}
      </div>
    </StyledCarousel>
  );
};

export default Carousel;
